import React from "react";
import { Box, Button } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <Button
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "58%",
        right: { md: "-130px", xs: "-80px" },
        zIndex: "1",
        transform: "translateY(-50%)",
        border: "none",
        borderRadius: "5px",
        padding: "10px",
        cursor: "pointer",
      }}
    >
      <KeyboardArrowRightIcon
        sx={{
          color: "white.main",
          fontSize: "100px",
        }}
      />
    </Button>
  );
};

export default CustomNextArrow;
